import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger)

export function heroWithOutline(element: HTMLElement) {
  let mm = gsap.matchMedia()
  const imageContainer = element.querySelector('.image')
  const image = element.querySelector('.image img')
  const ampersandContainer = element.querySelector('.ampersand') as HTMLElement
  let imageParallaxInstance: GSAPAnimation

  mm.add('(min-width: 850px)', () => {
    imageParallaxInstance = gsap.to(imageContainer, {
      y: '16%',
      ease: 'none',
      scrollTrigger: {
        trigger: element,
        start: `top top`,
        end: `bottom-=16% top`,
        scrub: true
      }
    })
  })

  function init(): void {
    ScrollTrigger.refresh()
  }

  function destroy(): void {
    if (imageParallaxInstance) imageParallaxInstance?.kill()
    mm.revert()
  }

  // Return the init and destroy functions
  return {
    init,
    destroy
  }
}
